import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Calificacion`

export function buscarCalificacion(idPublicacion) {
  return http.get(`${API_ENDPOINT}/BuscarCalificacion/${idPublicacion}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las calificaciones.',
      tipoError: 'calificacion'
    }
  })
}
